export default __webpack_public_path__ + "static/Pocket_MiniBio-160bc1c667bbcd2423791dd278c78f9c.webp";